import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const r = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser(r.data);
        navigate("/admin", { replace: true, state: { user: r.data } });
      } catch (err) {
        const msg =
          err?.response?.data?.detail || err?.message || "Sign-in failed";
        navigate("/admin/login", { replace: true, state: { error: msg } });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#0B0B0C] text-[#FAF9F6] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#D8A936] border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-6 font-display text-sm tracking-[0.24em] uppercase text-[#A9A9A6]">
          Signing you in…
        </p>
      </div>
    </div>
  );
}
